import * as React from 'react'

export const SVG_Edit = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
        <path
            fill="#4F5B68"
            fillRule="evenodd"
            d="M1.638 16.438L12.404 5.654 15.346 8.6 4.58 19.364l-2.965.02.023-2.946zm13.84-14.015l3.099 3.1L16.83 7.27l-3.1-3.1 1.747-1.746zM.022 15.75L0 20.069c0 .243.09.487.268.665A.89.89 0 0 0 .911 21l4.307-.021a.89.89 0 0 0 .643-.266L20.733 5.87a.934.934 0 0 0 0-1.307L16.472.266a.939.939 0 0 0-1.31 0l-2.973 2.992L.288 15.107a.987.987 0 0 0-.265.642z"
        />
    </svg>
)
